export function formatPrice(priceInCents: string): string {
  if (priceInCents === '0') return 'Grátis';

  return (Number(priceInCents) / 100).toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });
}
